export default "__VITE_ASSET__N995NALx__";